<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-笔记-修改
    -->
    <el-dialog
    title="笔记详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
    <el-form-item label="笔记介绍">
        <div class="edit_container">
          <div v-html=" form.context "></div>
        </div>
      </el-form-item>  



      <el-form-item label="媒体文件：" prop="form.media">
        <div class="draggable-list">
          <draggable class="wrapper">
            <transition-group>
              <div v-for="(itemA, indexA) in form.media" :key="itemA.file_path">
                <div class="item" :style="itemA.type === 2 ? 'width: 300px; height: 200px;' : ''">
                  <template v-if="itemA.type === 1">
                    <img v-img-url="itemA.file_path" alt="file_path"/>
                    <div class="openx" @click="opena(itemA.file_path)">打开文件</div>
                  </template>
                  <template v-else-if="itemA.type === 2">
                    <video controls :src="itemA.file_path" width="300" height="200" alt="file_path"></video>
                  </template>
                  <!-- <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(indexA, itemA.type)"><i class="el-icon-close"></i></a> -->
                </div>
              </div>
            </transition-group>
          </draggable>
          <!-- <div class="item img-select" @click="openMediaUpload(index)">
            <i class="el-icon-plus"></i>
          </div> -->
        </div>
      </el-form-item>


      <el-form-item label="发布时间" prop="publish_time">
        <!-- <el-date-picker v-model="form.publish_time" type="datetime" placeholder="选择发布时间" class="max-w460"></el-date-picker> -->
         {{ form.publish_time }}
      </el-form-item>

      <el-form-item label="关联其他作者" prop="associated_authors">
        <!-- <el-input v-model="form.associated_authors" placeholder="请输入关联其他作者" class="max-w460"></el-input> -->
         <ul class="d-s-s select-user">
              <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in form.associated_authors" :key="index">
                  <img :src="item.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
              </li>
            </ul>
      </el-form-item>

      <el-form-item label="提到的朋友" prop="mentioned_friends">
        <!-- <el-input v-model="form.mentioned_friends" placeholder="请输入提到的朋友" class="max-w460"></el-input> -->
        <ul class="d-s-s select-user">
              <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in form.mentioned_friends" :key="index">
                  <img :src="item.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
              </li>
            </ul>
      </el-form-item>

      <el-form-item label="标签" prop="tags">
        <ul class="d-s-s select-user">
              <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in form.tags" :key="index">
                 
                  <p class="lh18 ww100 text-ellipsis">{{item}}</p>
              </li>
            </ul>
      </el-form-item>

   


      <el-form-item label="最后更新时间" prop="last_updated">
        {{ form.last_updated }}
        <!-- <el-date-picker v-model="form.last_updated" type="datetime" placeholder="选择最后更新时间" class="max-w460"></el-date-picker> -->
      </el-form-item>


      <el-form-item label="笔记审核状态" prop="review_status">
         <div v-if="form.review_status == 0">待审核</div>
         <div v-if="form.review_status == 1">已审核</div>
         <div v-if="form.review_status == 2">未通过</div>
      </el-form-item>

      <el-form-item label="笔记审核未通过" prop="review_val">

          {{ form.review_val }}
      </el-form-item>

      <el-form-item label="笔记类型" prop="note_type">
        <div v-if="form.review_status == 1">正式</div>
        <div v-if="form.review_status == 0">草稿</div>
      </el-form-item>

      <el-form-item label="阅读量设置" prop="likes">
          <el-row>
            <el-col :span="8"  >
              <el-form-item label="阅读量" >
        
                  <el-input v-model="form.views" placeholder="请输入阅读量"  ></el-input>
                  {{ form.views }}
    
                </el-form-item>
           
            </el-col>
            <el-col :span="8" >
              <el-form-item label="虚拟阅读量" >
              {{ form.fview }}
            </el-form-item>
   
            </el-col>
    
        
          </el-row>
      </el-form-item>


      <el-form-item label="点赞数设置" prop="likes">
          <el-row>
            <el-col :span="8"  >
              <el-form-item label="点赞数" prop="likes">
                {{ form.likes }}
              </el-form-item>
           
            </el-col>
            <el-col :span="8">
              
            <el-form-item label="虚拟点赞数" prop="flikes">
              {{ form.flikes }}
            </el-form-item>
        
            </el-col>
    
        
          </el-row>
      </el-form-item>


      
      <el-form-item label="分享数设置" prop="shares">
          <el-row>
            <el-col :span="8"  >
              <el-form-item label="点赞数" prop="likes">
                {{ form.shares }}
              </el-form-item>
           
            </el-col>
            <el-col :span="8" >
              
            <el-form-item label="虚拟点赞数" prop="flikes">
          {{ form.fshares }}
            </el-form-item>
        
            </el-col>
    
        
          </el-row>
      </el-form-item>



      <el-form-item label="推荐/置顶设置" prop="likes">
          <el-row>
            <el-col :span="8"  >
             
              <el-form-item label="是否推荐" prop="is_featured">
           
                <div v-if="form.is_featured == 1">推荐</div>
                <div v-if="form.is_featured == 0">不推荐</div>
              </el-form-item>
                  
            </el-col>
            <el-col :span="8" >
              <el-form-item label="是否置顶" prop="is_pinned">
  
                <div v-if="form.is_pinned == 1">置顶</div>
                <div v-if="form.is_pinned == 0">不置顶</div>
              </el-form-item>
                  
   
            </el-col>
    
        
          </el-row>
      </el-form-item>



      <el-form-item label="上架/下架状态" prop="status">

        <div v-if="form.status == 1">上架</div>
        <div v-if="form.status == 0">下架</div>
      </el-form-item>

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
   </div>
</el-dialog>
  
</template>

<script>
import NotesApi from '@/api/notes.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        context:"",
        media:[],
        publish_time:"",
        associated_authors:"",
        mentioned_friends:"",
        tags:[],
        review_status:"",
        status:0,
        type:0,
        last_updated:"",
        views:0,
        fview:0,
        likes:0,
        flikes:0,
        shares:0,
        fshares:0,
        is_featured:0,
        is_pinned:0,
      },
      loading: false,
      /*验证规则*/
      rules: {
   
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","notes_id"],
  methods: {
  
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      NotesApi.detail({notes_id: self.notes_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.context;
          self.loading = false;
          if(!self.form.media){
            self.form.media = [];
          }
      
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.notes_id = self.notes_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          NotesApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}





.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/notes/index/part/detail.vue